import React, { useState, useEffect } from "react";
import LogoImg from "../../Assets/Images/updatedLogo.png";
import { useNavigate, useLocation } from "react-router-dom";
import { CgChevronDown } from "react-icons/cg";
import { BiLogOutCircle } from "react-icons/bi";
import "./Sidebar.css";

/* Import images for the categories */
import Dashboard_Icon from "../../Assets/Icons/Primary/Updated Icons/dashboard.png";
import Pages_Icon from "../../Assets/Icons/Primary/Updated Icons/pages.png";
import ECommerce_Icon from "../../Assets/Icons/Primary/Updated Icons/ecommerce.png";
import Appointment_Icon from "../../Assets/Icons/Primary/Updated Icons/appointment.png";
import Analytics_Icon from "../../Assets/Icons/Primary/Updated Icons/analytics.png";
import Marketing_Icon from "../../Assets/Icons/Primary/Updated Icons/marketing.png";
import Settings_Icon from "../../Assets/Icons/Primary/Updated Icons/setting.png";
import Blogs_Icon from "../../Assets/Icons/Primary/Updated Icons/blog.png";
import Security_Icon from "../../Assets/Icons/Primary/Updated Icons/security.png";
import AddsOn_Icon from "../../Assets/Icons/Primary/Updated Icons/addon.png";
import Performance_Icon from "../../Assets/Icons/Primary/Updated Icons/performance.png";
import Integrations_Icon from "../../Assets/Icons/Primary/Updated Icons/ads.png";
import SEO_Icon from "../../Assets/Icons/Primary/Updated Icons/seo.png";
import Forms_Icon from "../../Assets/Icons/Primary/Updated Icons/form.png";
import Header_Icon from "../../Assets/Icons/Primary/Updated Icons/Header .png";
import flyer_Icon from "../../Assets/Icons/Primary/Updated Icons/flyer.png";
import coupon_Icon from "../../Assets/Icons/Primary/Updated Icons/coupon_2.png";
import ptag_Icon from "../../Assets/Icons/Primary/Updated Icons/ptag.png";
import dyr_Icon from "../../Assets/Icons/Primary/Updated Icons/dyr.png";
import { useAuth } from "../../Context/Auth/AuthContext";
import Categories from "../../Pages/Page/Categories";

/* ---Sidebar Attributes--- */

const pagesAttributes = [
  { name: "Home", path: "/Pages/Home" },
  { name: "Landing Pages", path: "/Pages/Landing-Pages" },
  { name: "Categories", path: "/Pages/Categories" },
  { name: "FAQs", path: "/Pages/faqs" },
  { name: "Active Sale", path: "/Pages/Active-Sale" },
  { name: "Last Call Sale", path: "/Pages/last-call" },
  { name: "About", path: "/Pages/About" },
  { name: "Financing", path: "/Pages/Financing" },
  { name: "Shipping & Delivery", path: "/Pages/Shipping-&-Delivery" },
  { name: "Terms & Conditions", path: "/Pages/Terms-&-Conditions" },
  { name: "Privacy Policy", path: "/Pages/Privacy-Policy" },
  { name: "Return Policy", path: "/Pages/Return-Policy" },
];

const eComAttributes = [
  { name: "All Orders", path: "/E-Commerce/All-Orders" },

  { name: "All Products", path: "/E-Commerce/All-Products" },
  { name: "Add Product", path: "/E-Commerce/Add-Product" },
  { name: "Product Categories", path: "/E-Commerce/Product-Categories" },
  { name: "Product Attributes", path: "/E-Commerce/Product-Attributes" },
  { name: "Product Collections", path: "/E-Commerce/Product-Collections" },
  { name: "Product Features", path: "/E-Commerce/Product-Features" },
  { name: "Product Tags", path: "/E-Commerce/Product-Tags" },
  { name: "Product Reviews", path: "/E-Commerce/Product-Reviews" },
  { name: "Media Library", path: "/E-Commerce/media" },
  { name: "Customers", path: "/E-Commerce/Customers" },
  { name: "Stores", path: "/E-Commerce/Stores" },
  { name: "Settings", path: "/E-Commerce/Settings/Shipping" },
   { name: "Cart Abandoned", path: "/E-Commerce/cart-abandoned" },
   { name: "Cart Initiated", path: "/E-Commerce/cart-initiated" },
];



const headFootAttributes = [
  { name: "Header", path: "/Header-Footer/Header" },
  { name: "Footer", path: "/Header-Footer/Footer" },
];

const appointAttributes = [
  { name: "All Appointments", path: "/Appointments/All-Appointments" },
  { name: "Appointments Planner", path: "/Appointments/Appointments-Planner" },
];

const securityAttributes = [
  { name: "Cloudflare", path: "/Security/Cloudflare" },
  { name: "Firewall", path: "/Security/Firewall" },
  { name: "Server", path: "/Security/Server" },
];;

const analyticsAttributes = [
  { name: "Overview", path: "/Analytics/Overview" },
  { name: "Products", path: "/Analytics/Products" },
  { name: "Revenue", path: "/Analytics/Revenue" },
  { name: "Order", path: "/Analytics/Order" },
];


const settingsAttributes = [
  { name: "Users", path: "/Settings/Users" },
  { name: "Price Tags", path: "/Settings/Price-Tags" },
  { name: "Time Zones", path: "/Settings/Time-Zones" }
];

const formsAttributes = [
  { name: "All Forms", path: "/Forms/All-Forms" },
  { name: "Add Form", path: "/Forms/Add-Form" },
];

const blogsAttributes = [
  { name: "All Blogs", path: "/Blogs/All-Blogs" },
  { name: "Add Blog", path: "/Blogs/Add-Blog" },
  { name: "Categories", path: "/Blogs/Categories" },
  { name: "Tags", path: "/Blogs/Tags" },
];

const seoAttributes = [
  { name: "Home Page", path: "/SEO/Home" },
  { name: "Category Page", path: "/SEO/Category" },
  { name: "Active Sale Page", path: "/SEO/Active-Sale" },
  { name: "Product Archive Page", path: "/SEO/Product-Archive" },
  { name: "Product Page", path: "/SEO/Product" },
  { name: "Cart Page", path: "/SEO/Cart" },
  { name: "CheckOut Page", path: "/SEO/CheckOut" },
  { name: "Terms & Conditions", path: "/SEO/Terms-&-Conditions" },
  { name: "Privacy Policy", path: "/SEO/Privacy-Policy" },
  { name: "Refund Policy", path: "/SEO/Refund-Policy" },
  { name: "Financing Page", path: "/SEO/Financing" },
  { name: "Careers Page", path: "/SEO/Careers" },
  { name: "Contact Us", path: "/SEO/Contact-Us" },
  { name: "Store Locator", path: "/SEO/Store-Locator" },
];

const integrationAttributes = [
  { name: "Search Console", path: "/Integration/Search-Console" },
  { name: "Google Analytics", path: "/Integration/Google-Analytics" },
  { name: "Google Tags Manager", path: "/Integration/Google-Tags-Manager" },
  { name: "Google Ads", path: "/Integration/Google-Ads" },
  { name: "Meta Pixels", path: "/Integration/Meta-Pixels" },
  { name: "Meta Shop", path: "/Integration/Meta-Shop" },
  { name: "Tiktok Pixels", path: "/Integration/Tiktok-Pixels" },
  { name: "Google Merchant", path: "/Integration/Google-Merchant" },
  { name: "Microsoft Merchant", path: "/Integration/Microsoft-Merchant" },
  { name: "Bing Console", path: "/Integration/Bing-Console" },
  { name: "Yahoo Console", path: "/Integration/Yahoo-Console" },

];

const performanceAttributes = [
  { name: "Speed", path: "/Performance/In-Sight" },
  { name: "Health", path: '/Performance/Database-In-Sight' },
  { name: "Cache", path: '/Performance/Cache' },
  { name: "Server Logs", path: '/Performance/Server-Logs' }
];

const pTagsAttributes = [
  { name: "Price Tags", path: "/Price-Tags" },
];

const flyersAttributes = [
  { name: "Flyers", path: "/Flyers" },
];

const addOnsAttributes = [
  // { name: "Price Tags", path: "/Add-Ons/Price-Tags" },
  { name: "Coupons", path: "/Coupons" },
  // { name: "Flyers", path: "/Add-Ons/Flyers" },
  // { name: "Settings", path: "/Add-Ons/Settings" },
];

const permissionsAttributes = [
  // { name: "Price Tags", path: "/Add-Ons/Price-Tags" },
  { name: "Permissions", path: "/Permissions" },
  // { name: "Flyers", path: "/Add-Ons/Flyers" },
  // { name: "Settings", path: "/Add-Ons/Settings" },
];

const cartAttributes = [
  { name: "Failed Orders", path: "/E-Commerce/All-Failed-Orders" },
  { name: "Cart Abandoned", path: "/Cart/cart-abandoned" },
  { name: "Cart Initiated", path: "/Cart/cart-initiated" },
];


function Sidebar() {
  const { auth } = useAuth();
  const [hoveredCode, setHoveredCode] = useState(null);
  const [selectedTabCode, setSelectedTabCode] = useState(null);
  const [selectedChildrenByCode, setSelectedChildrenByCode] = useState({});
  const [openDropdownCode, setOpenDropdownCode] = useState(null);
  const [openSubDropdowns, setOpenSubDropdowns] = useState({});
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log(auth, "here is auth data");
  }, [auth]);

  const categories = [
    { name: "Dashboard", code: "DASHBOARD", path: "/Dashboard", grayImage: Dashboard_Icon, colorImage: Dashboard_Icon, isDropdown: false },
    { name: "Header", code: "HEADER", path: "/Header", grayImage: Header_Icon, colorImage: Header_Icon, isDropdown: false, attributes: headFootAttributes },
    { name: "Pages", code: "PAGES", path: "/Pages", grayImage: Pages_Icon, colorImage: Pages_Icon, isDropdown: true, attributes: pagesAttributes },
    { name: "E-Commerce", code: "E_COMMERCE", path: "/E-Commerce", grayImage: ECommerce_Icon, colorImage: ECommerce_Icon, isDropdown: true, attributes: eComAttributes },
    { name: "Appointments", code: "APPOINTMENTS", path: "/Appointments", grayImage: Appointment_Icon, colorImage: Appointment_Icon, isDropdown: true, attributes: appointAttributes },
    // { name: "SEO", code: "SEO", path: "/SEO", grayImage: SEO_Icon, colorImage: SEO_Icon, isDropdown: true, attributes: seoAttributes },
    { name: "Analytics", code: "ANALYTICS", path: "/Analytics", grayImage: Analytics_Icon, colorImage: Analytics_Icon, isDropdown: true, attributes: analyticsAttributes },
    { name: "Forms", code: "FORMS", path: "/Forms", grayImage: Forms_Icon, colorImage: Forms_Icon, isDropdown: true, attributes: formsAttributes },
    { name: "Blogs", code: "BLOGS", path: "/Blogs", grayImage: Blogs_Icon, colorImage: Blogs_Icon, isDropdown: true, attributes: blogsAttributes },
    { name: "Integration", code: "INTEGRATION", path: "/Integration", grayImage: Integrations_Icon, colorImage: Integrations_Icon, isDropdown: true, attributes: integrationAttributes },
    { name: "Performance", code: "PERFORMANCE", path: "/Performance", grayImage: Performance_Icon, colorImage: Performance_Icon, isDropdown: true, attributes: performanceAttributes },
    { name: "Security", code: "SECURITY", path: "/Security", grayImage: Security_Icon, colorImage: Security_Icon, isDropdown: true, attributes: securityAttributes },
    { name: "Price Tags", code: "PRICE_TAGS", path: "/Price-Tags", grayImage: ptag_Icon, colorImage: ptag_Icon, isDropdown: false, attributes: pTagsAttributes },
    { name: "Flyers", code: "FLYERS", path: "/Flyers", grayImage: flyer_Icon, colorImage: flyer_Icon, isDropdown: false, attributes: flyersAttributes },
    { name: "Coupons", code: "ADD_ONS", path: "/Coupons", grayImage: coupon_Icon, colorImage: coupon_Icon, isDropdown: false, attributes: addOnsAttributes },
    { name: "Settings", code: "SETTINGS", path: "/Settings", grayImage: Settings_Icon, colorImage: Settings_Icon, isDropdown: true, attributes: settingsAttributes },
    { name: "Permissions", code: "PERMISSIONS", path: "/Permissions", grayImage: AddsOn_Icon, colorImage: AddsOn_Icon, isDropdown: false, attributes: permissionsAttributes },
    { name: "Cart", code: "E_CART", path: "/Cart", grayImage: ECommerce_Icon, colorImage: ECommerce_Icon, isDropdown: true, attributes: cartAttributes },
  ];

// Inside render, before return:
const filteredCategories = categories.filter(cat =>
  auth?.permissions?.some(p => p.tab === cat.code)
);


useEffect(() => {
  const filtered = categories.filter(cat =>
    auth?.permissions?.some(p => p.tab === cat.code)
  );

  if (!location?.pathname || filtered.length === 0) return;

  const path = location.pathname;

  for (let cat of filtered) {
    if (cat.isDropdown && cat.attributes) {
      for (let i = 0; i < cat.attributes.length; i++) {
        const attr = cat.attributes[i];

        if (attr.path === path) {
          setSelectedTabCode(cat.code);
          setOpenDropdownCode(cat.code);
          setSelectedChildrenByCode({ [cat.code]: i });
          return;
        }

        if (attr.subcategories) {
          for (let j = 0; j < attr.subcategories.length; j++) {
            if (attr.subcategories[j].path === path) {
              setSelectedTabCode(cat.code);
              setOpenDropdownCode(cat.code);
              setSelectedChildrenByCode({ [cat.code]: `${i}-${j}` });
              return;
            }
          }
        }
      }
    } else if (cat.path === path) {
      setSelectedTabCode(cat.code);
      setOpenDropdownCode(null);
      setSelectedChildrenByCode({});
      return;
    }
  }
}, [auth?.permissions, location.pathname]);


  const handleMainItemClick= (code, path, isDropdown) => {
    console.log("Main item clicked:", code, "Is dropdown:", isDropdown);
    if (isDropdown) {
      setOpenDropdownCode(prev => (prev === code ? null : code));
      setSelectedTabCode(code); // <- this line is important
    } else {
      setSelectedTabCode(code);
      setSelectedChildrenByCode({});
      setOpenDropdownCode(null);
      navigate(path);
    }
  };


  const toggleSubDropdown = (parentCode, attrIndex) => {
    const key = `${parentCode}-${attrIndex}`;
    setOpenSubDropdowns(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const handleDropdownItemClick = (path, parentCode, attrIndex, hasSubcategories) => {
    if (hasSubcategories) {
      toggleSubDropdown(parentCode, attrIndex);
    } else {
      navigate(path);
      setSelectedTabCode(parentCode);
      setSelectedChildrenByCode({ [parentCode]: attrIndex });
    }
  };

  const handleSubDropdownItemClick = (path, parentCode, attrIndex, subIndex) => {
    navigate(path);
    setSelectedTabCode(parentCode);
    setSelectedChildrenByCode({ [parentCode]: `${attrIndex}-${subIndex}` });
  };

  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };

  return (
    <aside className="sidebar">
      <div className="logoSection">
        <img src={LogoImg} alt="Logo" className="logoImage" />
      </div>

      <div className="navSection">
        <nav>
          <ul>
            {filteredCategories.map((category) => (
              <React.Fragment key={category.code}>
                <li
                  className={`category-item ${selectedTabCode === category.code ? "active" : ""}`}
                  onMouseEnter={() => setHoveredCode(category.code)}
                  onMouseLeave={() => setHoveredCode(null)}
                  onClick={() => handleMainItemClick(category.code, category.path, category.isDropdown)}
                >
                  <span className={`navItem ${selectedTabCode === category.code ? "active" : ""}`}>
                    <span className="navItemContent">
                      <img
                        src={
                          hoveredCode === category.code || selectedTabCode === category.code
                            ? category.colorImage
                            : category.grayImage
                        }
                        alt={category.name}
                        className="catImage"
                      />
                      <p className="catName">{category.name}</p>
                    </span>
                    {category.isDropdown && (
                      <CgChevronDown className={`dropdownIcon ${openDropdownCode === category.code ? "open" : ""}`} />
                    )}
                  </span>
                </li>

                {/* Dropdown items */}
                {category.isDropdown && selectedTabCode === category.code && openDropdownCode === category.code && (
                  <ul className="dropdownList">

                    {category.attributes.map((attr, attrIndex) => (
                      <React.Fragment key={attrIndex}>
                        <li
                          className={`dropdownItem ${selectedChildrenByCode[category.code] === attrIndex ||
                            (typeof selectedChildrenByCode[category.code] === "string" &&
                              selectedChildrenByCode[category.code].startsWith(`${attrIndex}-`))
                            ? "active"
                            : ""
                            }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDropdownItemClick(attr.path, category.code, attrIndex, attr.subcategories);
                          }}
                        >
                          <div className="dropdownItemContent">
                            {attr.name}
                            {attr.subcategories && (
                              <CgChevronDown
                                className={`subdropdownIcon ${openSubDropdowns[`${category.code}-${attrIndex}`] ? "open" : ""
                                  }`}
                              />
                            )}
                          </div>
                        </li>

                        {attr.subcategories && openSubDropdowns[`${category.code}-${attrIndex}`] && (
                          <ul className="subDropdownList">
                            {attr.subcategories.map((sub, subIndex) => (
                              <li
                                key={subIndex}
                                className={`subDropdownItem ${selectedChildrenByCode[category.code] === `${attrIndex}-${subIndex}` ? "active" : ""
                                  }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleSubDropdownItemClick(sub.path, category.code, attrIndex, subIndex);
                                }}
                              >
                                {sub.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            ))}
          </ul>
        </nav>
      </div>

      <div
        className="logoutSection"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <button className={`logoutButton ${ "square"}`} onClick={handleLogout}>
          <BiLogOutCircle className={isHovered ? "logoutIcon" : "logoutIcon"} />
          {<span>Logout</span>}
        </button>
      </div>
    </aside>
  );
}


export default Sidebar;